<template>
    <div>
        <div class="columns">
            <div class="column">
                <services-upcoming-table class="services-table" :filter="filters" />
            </div>
        </div>
        <div class="columns">
            <div class="services-container">
                <open-services-table class="services-table" :data="rawData" :filters="filters" :loading="loading" />
            </div>
        </div>
<!--      <services-upcoming-table />-->

      <open-services-table class="services-table" :data="rawData" :filters="filters" :loading="loading" />

      <services-per-user-table class="services-table" :data="rawData" :filters="filters" :loading="loading" />
        <div class="columns">
            <open-expenses-table class="services-table open-expenses" :filters-prop="filters" :loading="loading" />
        </div>
    </div>
</template>

<script>
    import OpenExpensesTable from './OpenExpensesTable'
    import OpenServicesTable from './OpenServicesTable'
    import ServicesPerUserTable from './ServicesPerUserTable'
    import ServicesUpcomingTable from './ServicesUpcomingTable'

    export default {
        components: {
            OpenExpensesTable,
            OpenServicesTable,
            ServicesPerUserTable,
            ServicesUpcomingTable,
        },

        data() {
            return {
                groupByFilter: [
                    "service",
                    "user",
                ],
                items: [],
                loading: false,
                rawData: [],
                servicesColumns: [],
                servicesOverviewTableColumns: [],
                servicesTotalsObject: {},
            }
        },

        methods: {

            fetchData() {
                this.loading = true
                const params = { ...this.filters, groupBy: this.groupByFilter }
                return axios.get(`/api/reports/services-overview-report`, { params })
                    .then(res => {
                        this.rawData = res.data.data
                        return res
                    }).finally(() => {
                        this.loading = false
                        this.$forceUpdate()
                    })
            },

        },

        mounted() {
            this.fetchData()
        },

        props: {
            filters: {
                type: Object,
                default () {
                    return {
                        allDates: false,
                        converted_from: null,
                        converted_to: null,
                        exclude_services: [],
                        from: null,
                        projects: [],
                        services: [],
                        team_id: null,
                        to: null,
                        users: [],
                    }
                },
            },
        },

        watch: {
            filters: {
                deep: true,
                handler() {
                    this.fetchData()
                }
            },
        },
    }
</script>

<style lang="sass">
.services-container
  padding: 0.5rem 24px 0.5rem 0.5rem

.services-table
  margin-top: 15px
  &:last-child
    margin-bottom: 35px
  table
    white-space: nowrap
  &.open-expenses
    margin-top: 55px
</style>